import toast from "react-hot-toast";

export const getVideoInfo = async (file) => {
    return new Promise(function (resolve, reject) {
        var video = document.createElement('video');
        video.src = URL.createObjectURL(file);
        video.onerror = function (err) {
            clearInterval(intervalId);
            reject(err);
        };
        var intervalId = setInterval(function () {
            if (video.duration) {
                clearInterval(intervalId);
                URL.revokeObjectURL(video.src);
                resolve({
                    duration: video.duration,
                    size: file.size,
                    bitrate: (file.size / video.duration) * 8,
                });
            }
        }, 1);
    });
};

export const getImageSize = async (file) => {
    return new Promise(function (resolve, reject) {
        var image = document.createElement('img');
        image.src = URL.createObjectURL(file);
        image.onerror = function (err) {
            clearInterval(intervalId);
            reject(err);
        };
        var intervalId = setInterval(function () {
            if (image.naturalWidth && image.naturalHeight) {
                clearInterval(intervalId);
                URL.revokeObjectURL(image.src);
                resolve({
                    width: image.naturalWidth,
                    height: image.naturalHeight
                });
            }
        }, 1);
    });
};

export async function checkIfFileExistsOnS3(bucket: string, key: string) {
    try {
        const response = await fetch('/api/s3-check-file', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ bucket, key }),
        });

        if (!response.ok) {
            throw new Error('Failed to check file existence');
        }

        const data = await response.json();
        return data.exists;
    } catch (error) {
        console.error('Error checking file existence:', error);
        toast.error('Error checking file existence');
        return false;
    }
}

export async function uploadOnS3(file: File, bucket: string, key: string) {
    try {
        // Get presigned URL for PUT upload
        const presignedResponse = await fetch('/api/s3-presigned-url', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                bucket,
                key,
                contentType: file.type || 'application/octet-stream'
            }),
        });

        if (!presignedResponse.ok) {
            const errorData = await presignedResponse.json();
            throw new Error(errorData.error || 'Failed to get presigned URL');
        }

        const { presignedUrl, fileUrl } = await presignedResponse.json();

        const uploadResponse = await fetch(presignedUrl, {
            method: 'PUT',
            body: file,
            headers: {
                'Content-Type': file.type || 'application/octet-stream',
            },
        });

        if (!uploadResponse.ok) {
            throw new Error(`Upload failed with status: ${uploadResponse.status}`);
        }

        return fileUrl;
    } catch (error) {
        console.error('Upload error:', error);
        toast.error('Error in upload: ' + error.message);
        throw error;
    }
}